import { render } from "./download-app.vue?vue&type=template&id=990464e4&scoped=true"
import script from "./download-app.vue?vue&type=script&lang=js"
export * from "./download-app.vue?vue&type=script&lang=js"

import "./download-app.vue?vue&type=style&index=0&id=990464e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-990464e4"]])

export default __exports__